import {configureStore, getDefaultMiddleware} from "@reduxjs/toolkit";
// import createSagaMiddleware from "redux-saga";
import {reduxBatch} from "@manaflair/redux-batch";
import {persistStore,persistReducer} from "redux-persist";
import {rootReducer} from "./rootReducer";
// import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';


const persistConfig = {
  key: 'app',
  storage: storage,
  // blacklist: ['navigation'],
  whitelist: ["user"]
  // stateReconciler: autoMergeLevel2
};
const pReducer = persistReducer(persistConfig, rootReducer);

// const sagaMiddleware = createSagaMiddleware();
const middleware = [
  ...getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
    thunk: true
  }),
  // sagaMiddleware
];

const store = configureStore({
  // reducer: rootReducer,
  reducer: pReducer,
  middleware,
  devTools: process.env.NODE_ENV !== "production",
  enhancers: [reduxBatch]
});

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

// sagaMiddleware.run(rootSaga);

export default store;
